<div class="reset-limit-general-container">
  <div class="reset-limit-header">
    {{ 'reset_limit_dialog_text_1' | t }}
  </div>
  <div class="reset-limit-description">
    {{ 'reset_limit_dialog_text_2' | t }}
  </div>
  <div class="reset-limit-button-container" (click)="resetSelfLimits()">
    <div class="btn colored register-button save-changes-button confirm-button flexible green">
      <div class="btn-text" style="color: #fff !important">
        {{ 'Confirm' | t }}
      </div>
    </div>
  </div>
  <div class="reset-limit-sup-description">
    {{ 'reset_limit_dialog_text_3' | t }}
  </div>
</div>
